import $store from '@/store'

const routes = [
  {
    name: 'credits',
    path: '/credits',
    component() {
      return import('@/pages/credit/Credits.vue')
    },
  },
  {
    name: 'credits/detail/confirm',
    path: '/credits/:uuid/confirm',
    component() {
      return import('@/pages/credit/CreditsDetailConfirm.vue')
    },
  },
  {
    name: 'credits/detail/complete',
    path: '/credits/:uuid/complete',
    component() {
      return import('@/pages/credit/CreditsDetailComplete.vue')
    },
  },
  {
    name: 'credits/detail/choice',
    path: '/credits/:uuid/choice',
    component() {
      return import('@/pages/credit/CreditsChoice.vue')
    },
  },
]

// routes.forEach((router) => {
//   router.beforeEnter = async (to, from, next) => {
//     if ($store.getters['contract/status'] !== $store.state.contract.statusNames.COMPLETED) {
//       let msg = ''
//       if ($store.getters['contract/status'] === $store.state.contract.statusNames.DOES_NOT_EXIST) {
//         msg = '작성'
//       } else {
//         msg = '승인'
//       }
//       const html = `계약서 ${msg} 후 이용이 가능 합니다.`
//       await $swal.basic.alert({
//         html,
//       })
//       return next('/my/contract/info')
//     }
//     next()
//   }
// })

export default routes
